export default __webpack_public_path__ + "static/media/play.0eeeecd3.svg";